import { render } from "./DownloadHengxing.vue?vue&type=template&id=1c7d8c82&scoped=true"
import script from "./DownloadHengxing.vue?vue&type=script&lang=js"
export * from "./DownloadHengxing.vue?vue&type=script&lang=js"

import "./DownloadHengxing.vue?vue&type=style&index=0&id=1c7d8c82&scoped=true&lang=css"

import exportComponent from "/workspace/wum/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c7d8c82"]])

export default __exports__